const LinkedInIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 0 46 46"
      className={className}
    >
      <g clipPath="url(#clip0_2098_10419)">
        <path
          fill="currentColor"
          d="M17.174 31.626h-4.19V18.19h4.19v13.436zm-2.097-15.269c-1.34 0-2.427-1.105-2.427-2.439 0-.64.256-1.255.71-1.709a2.432 2.432 0 013.433 0c.455.454.71 1.068.71 1.71 0 1.333-1.087 2.438-2.426 2.438zm17.78 15.27h-4.18v-6.541c0-1.56-.032-3.558-2.18-3.558-2.178 0-2.512 1.693-2.512 3.445v6.653h-4.186V18.19h4.019v1.833h.059c.56-1.056 1.926-2.17 3.965-2.17 4.24 0 5.02 2.78 5.02 6.393v7.38h-.005z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2098_10419">
          <path
            fill="#fff"
            d="M0 0H20.212V23H0z"
            transform="translate(12.65 11.5)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export default LinkedInIcon;
